import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Stack, Typography, Button } from '@mui/material';
import PartnersStrip from '../../components/public/PartnersStrip';
import { CREAM, CREAM_SOFT, DISPLAY, INDIGO, INK, MONO, RULE, SANS, YELLOW, YELLOW_DEEP } from '../../components/public/publicTokens';

/** Header y footer del centro de ayuda, con la misma voz que la landing (crema, tinta, amarillo). */
const navLink = {
  fontFamily: SANS,
  fontSize: '0.9rem',
  color: INK,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline', textUnderlineOffset: 4 },
};

const footerLink = {
  display: 'block',
  fontFamily: SANS,
  fontSize: '0.9rem',
  color: 'rgba(255,255,255,0.82)',
  textDecoration: 'none',
  mb: 1,
  '&:hover': { color: YELLOW },
};

const AyudaShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ bgcolor: CREAM, color: INK, fontFamily: SANS, minHeight: '100vh', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>
    <Box component="header" sx={{ position: 'sticky', top: 0, zIndex: 30, bgcolor: CREAM, borderBottom: `1px solid ${RULE}` }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ py: 1.8 }}>
          <Box component={RouterLink} to="/" sx={{ textDecoration: 'none', color: INK }}>
            <Typography sx={{ fontFamily: DISPLAY, fontSize: '1.5rem', lineHeight: 1 }}>
              Dash<Box component="span" sx={{ fontStyle: 'italic', color: YELLOW_DEEP }}>Flow</Box>
            </Typography>
          </Box>
          <Box component={RouterLink} to="/ayuda" sx={{ ...navLink, display: { xs: 'none', sm: 'inline' }, fontFamily: MONO, fontSize: '0.72rem', letterSpacing: '0.16em', textTransform: 'uppercase', opacity: 0.7 }}>
            Centro de ayuda
          </Box>
          <Box sx={{ flex: 1 }} />
          <Box component={RouterLink} to="/login" sx={navLink}>
            Ingresar
          </Box>
          <Button
            component={RouterLink}
            to="/register"
            sx={{
              bgcolor: INK,
              color: CREAM_SOFT,
              borderRadius: 999,
              px: 2.4,
              py: 1,
              fontFamily: SANS,
              fontWeight: 600,
              fontSize: '0.85rem',
              textTransform: 'none',
              whiteSpace: 'nowrap',
              '&:hover': { bgcolor: INDIGO },
            }}
          >
            Empezar gratis
          </Button>
        </Stack>
      </Container>
    </Box>

    <Box component="main" sx={{ flex: 1 }}>
      {children}
    </Box>

    <Box component="footer" sx={{ bgcolor: INK, color: CREAM_SOFT, py: { xs: 6, md: 8 }, pb: { xs: 12, md: 8 } }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 } }}>
        <PartnersStrip />
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={4}>
          <Box sx={{ maxWidth: 380 }}>
            <Typography sx={{ fontFamily: DISPLAY, fontSize: '1.8rem', lineHeight: 1, mb: 1.5 }}>
              Dash<Box component="em" sx={{ fontStyle: 'italic', color: YELLOW }}>Flow</Box>
            </Typography>
            <Typography sx={{ fontFamily: SANS, fontSize: '0.88rem', color: 'rgba(255,255,255,0.62)' }}>
              Gestión de stock, ventas y caja para comercios. Hecho en Argentina.
            </Typography>
          </Box>
          <Stack direction="row" spacing={6}>
            <Box>
              <Typography sx={{ fontFamily: MONO, fontSize: '0.7rem', letterSpacing: '0.2em', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', mb: 2 }}>
                Producto
              </Typography>
              <Box component={RouterLink} to="/" sx={footerLink}>Inicio</Box>
              <Box component={RouterLink} to="/precios" sx={footerLink}>Planes y precios</Box>
              <Box component={RouterLink} to="/ayuda" sx={footerLink}>Centro de ayuda</Box>
            </Box>
            <Box>
              <Typography sx={{ fontFamily: MONO, fontSize: '0.7rem', letterSpacing: '0.2em', color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', mb: 2 }}>
                Cuenta
              </Typography>
              <Box component={RouterLink} to="/login" sx={footerLink}>Ingresar</Box>
              <Box component={RouterLink} to="/register" sx={footerLink}>Crear cuenta</Box>
              <Box component={RouterLink} to="/terminos" sx={footerLink}>Términos y Condiciones</Box>
              <Box component={RouterLink} to="/privacidad" sx={footerLink}>Privacidad</Box>
            </Box>
          </Stack>
        </Stack>
        <Typography sx={{ mt: { xs: 5, md: 7 }, pt: 3, borderTop: '1px solid rgba(255,255,255,0.1)', fontFamily: MONO, fontSize: '0.7rem', letterSpacing: '0.14em', color: 'rgba(255,255,255,0.45)' }}>
          © {new Date().getFullYear()} · DASHFLOW · TODOS LOS DERECHOS RESERVADOS
        </Typography>
      </Container>
    </Box>
  </Box>
);

export default AyudaShell;
